module.exports = __webpack_public_path__ + "img/freshpet.ca6eb535.png";